<template>
  <div :class="[loadingCompleted ? 'd-flex' : 'd-none']" class="align-items-center justify-content-between h4 m-3 p-3 bg-white rounded-md shadow-custom">
    <span class="font-weight-normal text-customize mt-n1">{{ totalPoint | currency }}</span>
    <span class="font-size-md mx-1 flex-grow-1">{{ pointUnit }}</span>
    <b-button
      v-if="hasTransferButton"
      @click="$emit('transfer')"
      variant="outline-light"
      class="px-4 bg-white text-customize border-customize">
      {{ $t('point-history.transfer') }}
    </b-button>
  </div>
</template>

<script>
import pageSettingGetter from '@/utils/pageSettingGetter';

export default {
  data() {
    return {
      // 資料是否完成載入
      loadingCompleted: false,
      // 會員積點總和
      totalPoint: 0,
      // 積點單位
      pointUnit: '',
      // 是否顯示轉贈按鈕
      hasTransferButton: false,
    };
  },
  created() {
    const vm = this;

    // 取得頁面設定資料
    const getPageSetting = vm.$store.dispatch('getPageSetting', 'UserPointHistory');
    getPageSetting.then((setting) => {
      vm.pointUnit = pageSettingGetter.getFunctionWording(setting, 'UserPointUnit');
    });

    // 取得會員積點
    const getMemberBonus = vm.$store.dispatch('getMemberBonus');
    getMemberBonus.then((memberBonus) => {
      vm.totalPoint = memberBonus.pointSum;
    });

    // 取得會員來源設定資料
    const getMemberSourceSetting = vm.$store.dispatch('getMemberSourceSetting');

    Promise.all([getPageSetting, getMemberBonus, getMemberSourceSetting])
      .then((res) => {
        const { isTransferPoint } = res[0];
        const { normalRegrType } = res[2];
        vm.hasTransferButton = isTransferPoint && (normalRegrType === 'Mobile' || normalRegrType === 'SMS');
        vm.loadingCompleted = true;
      });
  },
};
</script>
